import { NavLink } from 'react-router-dom';
import { Users, BarChart3, Lightbulb, User, Shield } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useAuthStore } from '@/stores/authStore';

const TABS = [
  { path: '/members', label: 'Members', icon: Users },
  { path: '/charts', label: 'Charts', icon: BarChart3 },
  { path: '/insights', label: 'Insights', icon: Lightbulb },
  { path: '/profile', label: 'Profile', icon: User },
];

export function BottomNav() {
  const isAdmin = useAuthStore((s) => s.isAdmin());

  const tabs = isAdmin
    ? [...TABS.slice(0, 3), { path: '/admin', label: 'Admin', icon: Shield }, TABS[3]]
    : TABS;

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-30 md:hidden glass border-t border-border pb-safe">
      <div className="flex items-center justify-around h-14">
        {tabs.map((tab) => (
          <NavLink
            key={tab.path}
            to={tab.path}
            className={({ isActive }) =>
              cn(
                'flex flex-col items-center gap-0.5 px-3 py-1.5 rounded-lg transition-colors min-w-[56px]',
                isActive
                  ? 'text-primary bg-primary/10'
                  : 'text-muted-foreground'
              )
            }
          >
            <tab.icon className="h-5 w-5" />
            <span className="text-[10px] font-medium">{tab.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
